import { render } from "./UserPortal.vue?vue&type=template&id=35271c64"
import script from "./UserPortal.vue?vue&type=script&lang=js"
export * from "./UserPortal.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__